<div *ngIf="loading" class="waiting-spinner">
  <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
  <p>Loading...</p>
</div>
<div *ngFor="let credentialGroup of credentialGroupResults" class="credential-group-container">
  <h3 class="group-name">{{ credentialGroup.groupName }}</h3>
  <p class="no-credential-text" *ngIf="!credentialGroup.credentials || credentialGroup.credentials.length == 0">
    You have no {{ credentialGroup.groupName }}
  </p>
  <section class="page-section credential-section" *ngFor="let credential of credentialGroup.credentials">
    <div class="mt-1 header-row">
      <div class="header-text">
        <span class="credential-name">{{ credential.credentialName }}</span>
      </div>
      <div>
        <div class="rounded">
          <span>
            <svg width="10" height="10" class="mr-1">
              <circle [ngClass]="getColor(credential)" class="status-dot" cx="5" cy="5" r="4" stroke-width="0" />
            </svg>
            {{ getLabel(credential) }}
          </span>
        </div>
      </div>
    </div>
    <table class="credential-info-table">
      <tr>
        <td><b>Number</b></td>
        <td>{{ credential.credentialNumber ? credential.credentialNumber : 'Not Issued' }}</td>
      </tr>
      <tr>
        <td><b>Issue Date</b></td>
        <td>
          {{ credential.issueDate ? (credential.issueDate | date: 'mediumDate') : 'Not Issued' }}
        </td>
      </tr>
      <tr>
        <td><b>Expiration Date</b></td>
        <td>{{ credential.expirationDate ? (credential.expirationDate | date: 'mediumDate') : 'Not Issued' }}</td>
      </tr>
      <tr *ngIf="credential.specialties && credential.specialties.length > 0">
        <td valign="top"><b>Specialties</b></td>
        <td>
          <ng-container *ngFor="let specialty of credential.specialties">{{ specialty }}<br /></ng-container>
        </td>
      </tr>
    </table>
    <button
      *ngIf="!credential.application && credential.isRenewalAvailable"
      mat-raised-button
      color="primary"
      class="mb-1"
    >
      BEGIN RENEWAL
    </button>
    <div *ngIf="credential.application && credential.credentialStatus.status !== 'PreIssue'" class="application-info">
      <div>
        <p class="application-title">Renewal Application</p>
        <p class="application-start-date">Started {{ credential.application.startDate | date: 'mediumDate' }}</p>
      </div>
      <div>
        <div class="application-status">
          <span>
            <svg width="10" height="10" class="mr-1">
              <circle
                [ngClass]="CredentialStatusLabelColor[credential.application.customApplicationStatus.color]"
                class="status-dot"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            {{
              credential.application.customApplicationStatus.status === 'InProgress'
                ? 'In Progress'
                : credential.application.customApplicationStatus.status
            }}
          </span>
        </div>
      </div>
    </div>
  </section>
</div>
